import React from "react";

import { Box, Typography } from "@mui/material";

import { black, grayLight, moovsBlueLight } from "design-system/colors";

function NotificationItemChip(props) {
  const { icon, title, description } = props;
  return (
    <Box
      display="flex"
      alignItems="center"
      mt={2}
      py={0.6}
      px={1}
      border={1}
      width="fit-content"
      sx={{
        borderColor: grayLight,
        gap: "5px",
        borderRadius: "12px",
      }}
    >
      <Box display="flex" alignItems="center">
        <Box mr={0.5}>{icon}</Box>
        <Typography variant="overline" color={moovsBlueLight}>
          {title}
        </Typography>
      </Box>

      <Box ml={1}>
        <Typography variant="caption" color={black}>
          {description}
        </Typography>
      </Box>
    </Box>
  );
}

export default NotificationItemChip;
